import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Award, Code, TrendingUp, Users, CheckCircle, Shield } from 'lucide-react';

const JotformWhyChooseSection = () => {
  const { t } = useTranslation('jotform');
  const icons = [Award, Code, TrendingUp, Users, CheckCircle, Shield];
  const reasonsData = t('whyChoose.reasons', { returnObjects: true });
  const reasons = Array.isArray(reasonsData) ? reasonsData as Array<{
    title: string;
    description: string;
    icon: string;
  }> : [];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">{t('whyChoose.title')}</h2>
          <p className="text-xl text-muted-foreground">{t('whyChoose.subtitle')}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = icons[index];
            return (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6 space-y-4">
                  <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                    <IconComponent className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold">{reason.title}</h3>
                  <p className="text-muted-foreground">{reason.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default JotformWhyChooseSection;